<template>
  <div>
    <v-simple-table class="borderless-table">
      <template v-slot:default>
        <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Expiry Date
          </th>
          <th>
            Actions
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item,index) in mergedDocumentsList"
            :key="item.type + index"
            class="bg-white"
        >
          <td :style="{fontWeight: 'bold'}">
            {{ getDocumentTypeValue(item.type) }}
          </td>
          <td :style="{color: item.state == null || item.state === 'missing' ? 'red' : 'black'}">
            {{ item.state == null || item.state === 'missing' ? "MISSING" : item.state}}
          </td>
          <td :style="{color: checkDocumentExpiryDate(item.expiry_time) ? 'red' : 'black'}">
            {{ item.expiry_time }}
          </td>
          <td>
            <v-btn
                text
                x-small
                class="blue--text"
                @click="prepareUploadDialog(item)"
            >
              Upload
            </v-btn>
            <v-btn
                text
                class="blue--text"
                x-small
                @click="handleViewDocument(item.id)"
            >
              View
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-layout>
      <v-container>
        <v-flex>
          <v-dialog
              v-model="uploadDialog"
              width="500"
          >
            <v-card class="pa-3">
              <v-card-title class="headline grey lighten-2">
                Uploaded Document
                <v-spacer></v-spacer>
                <v-icon @click="uploadDialog = false">mdi-close</v-icon>
              </v-card-title>
              <UploadDriverDocument
                  class="pa-2"
                  :driver-document="selectedDocument"
                  :taxi-id="this.taxi.id"
                  @documentProcessed="refreshDocuments"
                  @viewDocument="handleViewDocument(selectedDocument.id)"/>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import UploadDriverDocument from '../../components/document/UploadDriverDocument'

export default {
  name: "TaxiDocumentsBox",
  components: {UploadDriverDocument},
  props: {
    taxi: Object,
  },
  data () {
    return {
      uploadDialog: false,
      documentTypes: [
        {
          type: 'Vehicle Insurance',
          value: 'insurance'
        },
        {
          type: 'Vehicle Plate',
          value: 'vehicle_plate'
        },
        {
          type: 'MOT Certificate',
          value: 'mot'
        },
        {
          type: 'Council Compliance Certificate',
          value: 'compliance_certificate'
        },
        {
          type: 'Road Tax',
          value: 'road_tax'
        },
      ],
      selectedDocument: ""
    }
  },
  computed:{
    mergedDocumentsList () {

      // return most recent completed document as the 'primary' document in the list

      let list = []
      this.documentTypes.forEach(documentType => {
        let existingDoc = this.taxiDocuments.find(taxiDoc => {
          return taxiDoc.type === documentType.value && taxiDoc.state === 'completed'
        })

        if (existingDoc) {
          list.push(existingDoc)
        }

        let existingRequiresVerificationDoc = this.taxiDocuments.find(taxiDoc => {
          return taxiDoc.type === documentType.value && taxiDoc.state === 'pending'
        })

        if (existingRequiresVerificationDoc) {
          list.push(existingRequiresVerificationDoc)
        } /*else if (!existingDoc){
          list.push(documentType)
        }*/

        let missingDoc = this.taxiDocuments.find(taxiDocument => {
          return taxiDocument.type == documentType.value && taxiDocument.state == 'missing'
        })

        if (missingDoc) {
          list.push(missingDoc)
        } else if (!existingDoc){
          list.push(documentType)
        }

      })
      return list
    },
    taxiDocuments () {
      return this.$store.getters['document/getTaxiDocuments'];
    }
  },
  watch: {
    taxi(newValue) {
      // Handle the updated prop value
      console.log('Prop changed:', newValue);
      this.loadDocuments();
    }
  },
  created() {
    console.log("Created");
    console.log("Taxi: ", this.taxi);
    this.loadDocuments()
  },
  methods: {
    getDocumentTypeValue: function(targetValue) {
      let documentType = this.documentTypes.find(type => type.value === targetValue);
      if(documentType === undefined){
        documentType = this.documentTypes.find(docType => docType.type === targetValue);
      }

      return documentType.type ;
    },
    prepareUploadDialog (document) {
      this.selectedDocument = document
      console.log("Selected Document in Upload", this.selectedDocument);
      this.uploadDialog = true
    },
    handleViewDocument: function (fileID) {
      let documentFile = this.taxiDocuments.find(function (document) {
        return document.id === fileID;
      });

      let self = this;
      let url = `${this.$store.state.apiUrl}/driver/getDocumentUrl`;
      axios({
        url: url,
        method: "GET",
        params: {
          key: documentFile.filename,
        },
      })
          .then(function (response) {
            if (response.data.error) {
              self.snackbarMessage = "Failed to retrieve file";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else {
              const link = document.createElement("a");
              link.href = response.data.url;
              link.target = "_blank";
              link.setAttribute("download", documentFile.name);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(function (error) {
            console.log(error);
            self.snackbarMessage = "Failed to retrieve file";
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
    },
    loadDocuments () {
      console.log("Loading documents");
      console.log(this.taxi);
      this.$store.dispatch('document/getTaxiDocuments', this.taxi.id)
    },
    refreshDocuments() {
      this.uploadDialog = false;
      this.loadDocuments();
    },
    checkDocumentExpiryDate: function (expiryDate) {
      let expiry = new Date(expiryDate);
      let today = new Date();

      return expiry < today;
    }
  }
}
</script>

<style >

.borderless-table table tr td,th {
  border: none !important;
}


</style>